/* @flow */
// typecheck: ignore file
import React from 'react';
import { throttle } from 'lodash';

import './styles/ScrollContainer.scss';

type Props = {
  scrollToBottom?: boolean,
  onScroll?: Function,
  children?: React$Element<*>, // FlowIssue github.com/facebook/flow/issues/1355
};

class ScrollContainer extends React.Component {
  props: Props;

  state = {
    scrollBottom: 0,
  };

  componentDidMount() {
    this.handleScroll = throttle(this.handleScroll, 100);
    if (this.props.scrollToBottom) {
      this.scrollToBottom();
    }
  }

  componentDidUpdate() {
    if (this.state.scrollBottom === 0) {
      if (this._container && this.props.scrollToBottom) {
        this._container.scrollTop = this._container.scrollHeight;
      }
    }
  }

  _container = null;

  handleScroll = () => {
    if (this._container) {
      const scrollBottom = this._container.scrollTop + this._container.offsetHeight - this._container.scrollHeight;
      this.setState({ scrollBottom }, this.props.onScroll);
    }
  };

  isScrolledToBottom(offset: number = 0): boolean {
    if (this._container) {
      const scrollTop = this._container.scrollTop;
      const scrollBottom = scrollTop + this._container.offsetHeight - this._container.scrollHeight;
      return scrollBottom + offset >= 0;
    }
    return false;
  }

  scrollToBottom() {
    this.setState({ scrollBottom: 0 }, this.props.onScroll);
  }

  scrollToTop() {
    if (this._container) {
      this._container.scrollTop = 0;
    }
  }

  // This prevents mousewheel events on ScrollableArea instances from transferring to mousewheel
  // on the document's main scroll area.
  handleWheel = (event: SyntheticWheelEvent) => {
    const node = this._container;
    if (!node) {
      return;
    }

    if (event.deltaX && !event.deltaY) {
      return;
    }

    const scrollHeight = node.scrollHeight;
    const clientHeight = node.clientHeight;
    if (scrollHeight > clientHeight) {
      const scrollTop = node.scrollTop;
      const delta = -event.deltaY;
      if ((delta > 0 && scrollTop === 0) ||
        (delta < 0 && scrollTop >= scrollHeight - clientHeight - 1)) {
        event.preventDefault();
      }
    }
  };

  render() {
    return (
      <div
        className="ScrollContainer"
        ref={(container) => (this._container = container)}
        onScroll={this.handleScroll}
        onWheel={this.handleWheel}>
        {this.props.children}
      </div>
    );
  }
}

export default ScrollContainer;



// WEBPACK FOOTER //
// ./src/components/ScrollContainer.jsx